import React from "react";
import services from "@config/services.json";
import Link from "next/link";
import { Title } from "@components/ui";
function ServiceNumber() {
    return (
        <>
            {services.map((service, index) => {
                return (
                    <>
                        <ServiceItem
                            title={service.title}
                            link={service.link}
                            imageSrc={service.imageSrc}
                            description={service.description}
                            key={index}
                        />
                    </>
                );
            })}
        </>
    );
}

function ServiceItem({ imageSrc, title, link, description }) {
    return (
        <Link href={link}>
            <a style={{ textDecoration: "none" }}>
                <div className="service-item torgid-background-secondary torgid-border">
                    <img className="service-image" src={imageSrc} />

                    <div className="service-item-description-container">
                        <Title size={2}>{title}</Title>

                        <p className="torgid-text-secondary">{description}</p>
                        <div className="d-flex flex-row-reverse">
                            <Link href={link}>
                                <button className="btn btn-primary service-item-read-more">
                                    Lesa meira
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
            </a>
        </Link>
    );
}
export default ServiceNumber;
